// Güneş Saatleri sonuç gösterimi için tasarım registry'si.
// Klasik (mevcut) görünüm de buradadır; böylece sayfada özel-durum kodu olmaz ve
// default tek sabitle (DEFAULT_SUN_DESIGN_ID) değiştirilebilir.

import KlasikDesign from './KlasikDesign.js';
import D1Meridyen from './D1Meridyen.js';
import D3Yorunge from './D3Yorunge.js';
import D4Safak from './D4Safak.js';
import D5Rasathane from './D5Rasathane.js';
import D6Yumusak from './D6Yumusak.js';

// ← Default görünümü değiştirmek için yalnızca bu satırı düzenleyin.
export const DEFAULT_SUN_DESIGN_ID = 'safak';

export const SUN_DESIGNS = [
  { id: 'klasik',    name: 'Klasik',    tag: 'Mevcut görünüm',            Component: KlasikDesign },
  { id: 'safak',     name: 'Şafak',     tag: 'İki tonlu · sıcak gradyan', Component: D4Safak },
  { id: 'meridyen',  name: 'Meridyen',  tag: 'Editöryel · veri tablosu',  Component: D1Meridyen },
  { id: 'yorunge',   name: 'Yörünge',   tag: 'Gökyüzü · gündüz yayı',     Component: D3Yorunge },
  { id: 'rasathane', name: 'Rasathane', tag: 'Vintage · takvim yaprağı',  Component: D5Rasathane },
  { id: 'yumusak',   name: 'Yumuşak',   tag: 'Neumorfizm · kabartma',     Component: D6Yumusak },
];

// Verilen id'yi bulur; bulunamazsa default tasarıma düşer.
export const getSunDesign = (id) =>
  SUN_DESIGNS.find((d) => d.id === id) ||
  SUN_DESIGNS.find((d) => d.id === DEFAULT_SUN_DESIGN_ID);
